import services from './../../services/service'; // Service Class
import commons from './../../services/commons'; // Service Class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer
import ProductList from '../../components/product/ProductList.vue'
import RightSidebar from './../../components/templates/rightsidebar.vue'; 
import LeftSidebar from './../../components/templates/leftsidebar.vue'; 
import SearchBox from './../../components/templates/searchbox.vue'; 
import Settings from './../../components/tools/settings.vue';
let service = new services();
let set = new commons();

export default {
    name: 'Home',
    data () {
        return {
            user:{},
            market:{},
            business:{},
            categories:{},
            subscriptions:{},
            business_service_categories:[],
            business_product_categories:[],
            business_category_type:0,
            plan1:{},
            plan2:{},
            plan3:{},
            selected_plan:{},
            selected_plan_product_service_item:{},
            selected_plan_product_service_actual_item:{}, //for discount from referral
            upgradable_plans:{},
            upgrade_business:"",
            set_upgrade_plans:false,
            place_order:false,
            //boarding_messages:[],
            data_boarding_message:"",
            set_up_with_existing_account: false,
            set_up_with_new_account:false,
            set_up_business:false,
            validate_user_name_error:false,
            data_error_message: "",
            payment_successful: false,
            payment_successful_message: "",
            payment_payer_name:"",
            payment_payer_email:"",
            payment_payer_phone:"",
            payment_service:"",
            payment_ref:"",
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            loading: true,
            action_loading:false,
            disable_btn:false,
            setup_error_message:"",
            newBusinessForm:false,
            product_service_items_select:"",
            set_upgrade_plan_process: false,
            refcode:"",
            refcode_discount:0,
            refcode_discounted_price:0,
        }
    },
  
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
        'right-sidebar': RightSidebar,
        'left-sidebar': LeftSidebar,
        'search-box': SearchBox,
        'c-settings':Settings,
    },
    computed: {
        
    },
    methods: {
        setCurrency(currency){
            return service.formatCurrency(currency);
        },

        setComponent(attr1,attr2){
            if(attr1 == 'setup-existing'){
                this.set_up_with_existing_account = true;
            }
            if(attr1 == 'not-setup-existing'){
                this.set_up_with_existing_account = false;
            }
            if(attr1 == 'show-new-business-form'){
                this.newBusinessForm = true;
            }
            if(attr1 == 'display-product_service_items'){
                //toggle display
                var x = document.getElementById("productServiceItems");
                if (x.style.display === "none") {
                    x.style.display = "block";
                } else {
                    x.style.display = "none";
                }
            }
            
        },
        reset(){
            this.set_upgrade_plan_process = false;
        },

        toggleDisplayFeatures(){
            var x = document.getElementById("seeFeatures");
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        },

        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },

        selectProductServiceItem(item){
            this.selected_plan_product_service_item = item;
            this.selected_plan_product_service_actual_item = item; //store for rehack
            if(this.refcode != ""){
                this.setReferralOptions();
            }
            
        },

        preset() {
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;

                            //check for upgrade request
                            if(this.$route.query.upgrade){
                                this.prepareUpgradePlans();
                            }
                        }, this);
                    }else {
                       //this.$router.push('/login/');
                      }
                }).catch((err) => {
                    if(err) {
                        //this.$router.push('/login/');
                    }
                })
            }else {
               //this.$router.push('/login/');
            }
        },

        setReferralOptions(){
            this.selected_plan_product_service_item = this.selected_plan_product_service_actual_item;
            if(this.refcode_discount != 0){
                let discounted_price = 0;
                discounted_price = (this.selected_plan_product_service_actual_item.product_item_price - ((this.refcode_discount/100)*this.selected_plan_product_service_actual_item.product_item_price))
                this.refcode_discounted_price = discounted_price;
            }
        },

        getReferralOptions(){
            service.getAppBusinessReferralCodeDetails(this, this.refcode).then(response => {
                if(response.body.status == 200){
                    this.refcode_discount = response.body.data.referral_discount;
                }else{
                    this.refcode_discount = 0;
                }
                
            }).catch((err) => {})
        },

        flowtrack(){ //check 
            //check if user is loggedin

            //check if user has a business request order 

            //if order not paid
            //show payment continuation prompt

            //if order was paid
            //show create business form

            //if order paid and business created navigate to businesss
        },

        setPurchase(){
            //get the route query
            let query_plan = this.$route.query.purchase; //the subscription product-service
            let query_plan_item = this.$route.query.item; //the actual subscription product-service item array index
           
            //set the matching plan
            let found = false;
            //loop through subscriptions
            this.subscriptions.forEach(function(element) {
                if(element.product_url_name == query_plan){
                    this.selected_plan = element;
                    if(query_plan_item != 'n'){ // 'n' is a default mark to show no product item assigned
                        if(element.product_items[query_plan_item]){ //check/confirm if array index exists recode later
                            this.selected_plan_product_service_item = element.product_items[query_plan_item];
                            this.selected_plan_product_service_actual_item = element.product_items[query_plan_item]; //store for rehack
                        }else{
                            this.selected_plan_product_service_item = element.product_items[0]; //assign ist in array
                            this.selected_plan_product_service_actual_item = element.product_items[0]; //store for rehack
                        }
                    }else{
                        this.selected_plan_product_service_item = element.product_items[0]; //still assign ist in array
                        this.selected_plan_product_service_actual_item = element.product_items[0]; //store for rehack
                    }
                    
                   
                    found = true;
                    //disable loading
                    this.loading = false;
                }
            }, this);
            
            //if noot found
            if(!found){
                this.setup_error_message = "Something went wrong with your selection, please pick another plan"
            }
             //if referral code is available
             if(this.refcode != ""){
                this.setReferralOptions();
               }
             //disable loading
            this.loading = false;

        },

        prepareUpgradePlans(){
            this.loading = true;
           
            let navi = this.$router; 
            service.getBusinessMarketUpgradeDetails(this, this.$route.query.upgrade).then(function(data) {
                this.upgradable_plans = data.body.data;
                this.upgrade_business = this.$route.query.upgrade;
                //set payment details
                this.payment_payer_name = data.body.data_user_payment_details["user_name"];
                this.payment_payer_email = data.body.data_user_payment_details["user_email"];
                this.payment_payer_phone = data.body.data_user_payment_details["user_phone"];
                //
                this.set_upgrade_plans = true;
                this.loading = false;
                
            })
        },

        getSellpointMarket(){
            service.getBusinessByUserName(this, service.market_app_name).then(response => {
                if(response.body.status == 200) {
                    this.market = response.body.data;
                    //document.title = this.sellpoint.business_name;
                    
                    //get market details
                    this.getMarketMainProductsAsSubscriptions();
                     

                    this.loading = false;

                }
            }).catch((err) => {
                //log it
                //location.replace("/");
              //console.log(err);
              this.loading = true;
            })
        },

        getMarketMainProductsAsSubscriptions(){
            service.getBusinessProducts(this, this.market.business_id).then(response => {
                if(response.body.status == 200) {
                    this.subscriptions = response.body.data;
                    this.plan1 = this.subscriptions[2];
                    this.plan2 = this.subscriptions[1];
                    this.plan3 = this.subscriptions[0];
                }
                //set up route if available
                if(this.$route.query.purchase){
                    this.setPurchase();
                }
                
            }).catch((err) => {})
                
        },

        purchase_plan_2(plan,plan_product_service_item_index){
            this.loading = true;
            this.$router.push('/purchase/?purchase='+plan.product_url_name+'&item='+plan_product_service_item_index);
            this.setPurchase();
            //srolls to the very top
            var top = document.getElementById("topwrap").offsetTop; //Getting Y of target element //general addPanelView otherwise use specific names
            window.scrollTo(0, top); 
        },

        purchase_plan(plan){
            this.loading = true;
            this.selected_plan = plan;
            this.selected_plan_product_service_item = plan.product_items[0]; //assign ist in array
        },

        upgrade_plan(plan){
            this.loading = true;
            this.set_upgrade_plan_process = true;
            this.selected_plan = plan;
            this.selected_plan_product_service_item = plan.product_items[0]; //assign ist in array
            this.loading = false;
            //show top
            var top = document.getElementById("topwrap").offsetTop;
            window.scrollTo(0, top);
        },

        resetOptions(){
            this.selected_plan = {};
            this.selected_plan_product_service_item = {},
            this.total_price = 0;
            this.place_order = false;
        },
    
        resetMessages(){
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },

        proceedUpgradePlan(){
            //loop through plan to get matching price
            let found = false
            this.selected_plan.product_items_upgrade_details.forEach(function(element) {
                if(this.selected_plan_product_service_item.product_item_id == element.subscription_new_product_item_id){
                    this.selected_plan_product_service_item.product_item_price = element.subscription_new_product_total_amount_to_pay;
                    found = true;
                }
            }, this);

            if(found){
                //prepare payment details

                //process pay
                this.processPayment();
            }
        },
        
        proceedNewAccount(){
            this.resetMessages();
            this.set_up_with_new_account = true;

            //create new user's account
            //create account by registering user
            // this.disable_btn = true;
            this.activate_processing();
            var credentials = {
                user_name: this.payment_payer_name,
                user_phone: this.payment_payer_phone,
                user_email: this.payment_payer_email,
                user_address:  '',
                user_state: '',
                user_city: '',
                user_password: this.user.user_password
            }


            let navi = this.$router;

            //test data
            let data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let email_test = re.test(String(this.payment_payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            let phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
            if((email_test == false) || (this.payment_payer_name == " ") || (phone_test == false)){
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
                this.deactivate_processing();
            }else{
                data_test = true;
                this.data_error_message = "";
            }
            if(data_test){
                if(credentials.user_name != undefined && credentials.user_address != undefined && credentials.user_phone != null &&
                credentials.user_email != null && credentials.user_password != null) {
                    service.regUser(this, credentials).then(function(data) {
                        if(data.body.status == 201) {
                        // toastr.success("Registration Successful", 'Success!');
                        this.data_boarding_message ="Registration Successful...";
                        //set user
                        this.user.user_name = this.payment_payer_name;
                        this.user.user_email = this.payment_payer_email;
                        this.user.user_phone = this.payment_payer_phone;
                        //process order
                        this.processOrder(1);
                        }else if(data.body.status == 409) {
                            //toastr.warning("This User is already registered", 'Warning!');
                            this.data_error_message = "This User is already registered..";
                            // this.disable_btn = false;
                            this.deactivate_processing();
                        }
                    })
                }else {
                    //toastr.error('Kindly fill all fields', 'Warning!');
                    this.data_error_message = "Kindly fill all fields...";
                    // this.disable_btn = false;
                    this.deactivate_processing();
                }
            }
         
            //test-switch
            // this.updatePayment("reffy");
        },

        proceedWithAccount(){
            this.resetMessages();
            this.activate_processing();
            var payload = {
                user_email: this.user.user_email,
                user_password: this.user.user_password,
                user_business: this.user.user_business
            }
            service.checkUserDetails(this, payload).then(function(data) {
                if(data.body.status == 200) {
                    if(data.body.status_2 != 200) {
                        this.data_error_message = "Sorry, Sellpoint does not exist on this account";
                        this.deactivate_processing();
                       // toastr.warning("Sorry, Sellpoint does not exist on this account", 'Warning!');
                    }else{
                        this.data_boarding_message = "Account verified...";
                        //update user's details
                        this.user.user_name = data.body.data.user_name;
                        this.user.user_email = data.body.data.user_email;
                        this.user.user_phone = data.body.data.user_phone;
                        //all good proceed
                        this.processOrder(0);
                    }
                }else{
                    this.data_error_message = "Sorry, Account does not exist";
                    this.deactivate_processing();
                   // toastr.warning("Sorry, Account does not exist", 'Warning!');
                }
            }).catch((err) => {})
        },

        processOrder(user_status){
            //log user in
            var payload = {
                user_email: this.user.user_email,
                user_password: this.user.user_password
            }
            service.loginUser(this, payload).then(response => {
                if(response.body.status == 200) {
                    let data = response.body.data;
                    localStorage.setItem("sp_user", data.user_name); 
                    localStorage.setItem("sp_token", data.user_session_key); //store session key here linked to session well @server
                    localStorage.setItem("sp_token_key", data.user_token_key); 
                    
                    //do settings
                    this.preset();
                    this.data_boarding_message = "Logging you in...";


                    //make order
                    var payload = {
                        order_new_user: user_status,  //0=existing user //1=not-existing-user
                        order_user_email: this.user.user_email,
                        order_product: this.selected_plan.product_id,
                        order_product_item: this.selected_plan_product_service_item.product_item_id,
                        order_amount_to_pay: this.selected_plan_product_service_item.product_item_price,
                        order_details:"Order Request For Gallery Website: "+this.selected_plan.product_name,
                        order_referral_code:this.refcode,
                        order_amount_to_pay_with_referral: this.refcode_discounted_price,
                    }
                    service.makeAppSubscriptionOrder(this, payload).then(response => {
                        if(response.body.status == 201) {
                            this.data_boarding_message = "Preparing your Order....";

                            this.payment_payer_name = this.user.user_name;
                            this.payment_payer_email = this.user.user_email;
                            this.payment_payer_phone = this.user.user_phone;
                            this.payment_ref = response.body.data_payref;
                            
                            // if(this.selected_plan.product_items[0].product_item_price == 0){ //free account
                            if(this.selected_plan_product_service_item.product_item_price == 0){ //free account
                                this.updatePayment("gw-free-account")
                            }else{
                                //proceed to pay
                                this.processPayment();
                            }

                        }else{ //if status is either 400 or 500
                            this.data_error_message = "Something went wrong";
                            this.deactivate_processing();
                        }
                    }).catch((err) => {
                        this.data_error_message = "invalid, Something went wrong"; 
                        this.deactivate_processing();
                    })
                }
            }).catch((err) => {
                if(err.status == 404) {
                    this.data_error_message = "invalid login credentials"; 
                    // this.disable_btn = false;
                    this.deactivate_processing();
                }
            })
        },

        //connect to a payment gateway
        processPayment() {
            //some onboarding
            this.data_boarding_message = "Preparing Payment Information";
            //test data
            let data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let email_test = re.test(String(this.payment_payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            let phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
            if((email_test == false) || (this.payment_payer_name == " ") || (phone_test == false)){
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
            }else{
                data_test = true;
                this.data_error_message = "";
            }
            if(data_test){
                 //process online payment
                    this.payment_service = "Gallery Website Order - " + this.selected_plan.product_name+"("+this.selected_plan_product_service_item.product_item_price+")";
                    let obj = this;
                    let amount_to_pay = 0;
                    if((this.refcode != "") && (this.refcode_discounted_price != 0)){
                        amount_to_pay = this.refcode_discounted_price;
                    }else{
                        amount_to_pay = this.selected_plan_product_service_item.product_item_price;
                    }
                    //this.amount_paid = data.plan_amount;
                    var handler = PaystackPop.setup({
                    key: 'pk_live_64fe633bf8a53b0346ef8a44f54dc41cc0aa9f8b',
                    // key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
                    Name: this.payment_payer_name,
                    // email: data.plan_user_email || "admin@sellpoints.ng",
                    email: this.payment_payer_email,
                    amount:  (Math.round(amount_to_pay * 100)),//(data.plan_amount * 100), //in kobo
                    ref: this.payment_ref,//"GWLOG"+(new Date().getTime()),
                    metadata: {
                        custom_fields: [
                            {
                                display_name: "GalleryWebsite Order",
                                variable_name: "",
                                value: this.payment_payer_name + " - " + this.payment_payer_phone + " - ORDER - " + this.selected_plan.product_name
                            },
                            {
                                display_name: "Service",
                                variable_name: "service_type",
                                value: this.selected_plan.product_name
                            }
                            
                        ]
                    },
                    
                    callback: function(response){
                        obj.updatePayment(response.trxref); 
                    },
                    onClose: function(){
                        obj.data_boarding_message = "You Stopped Payment..";
                        //call flowtrack
                        obj.flowtrack();
                        obj.deactivate_processing()
                        alert('window closed');
                        
                    }
                    });
                    handler.openIframe();
                }

        },

        //connect to a payment gateway with ///RAVEPAY-SETUP
        processPaymentRave() {
            //some onboarding
            this.data_boarding_message = "Preparing Payment Information";
            //test data
            let data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let email_test = re.test(String(this.payment_payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            let phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
            if((email_test == false) || (this.payment_payer_name == " ") || (phone_test == false)){
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctlyaaa"+this.payment_payer_name+"se"+this.payment_payer_phone+"33"+this.payment_payer_email;
                this.data_boarding_message = "";
            }else{
                data_test = true;
                this.data_error_message = "";
            }
            if(data_test){
                let self = this;
                let amount_to_pay = 0;
                if((this.refcode != "") && (this.refcode_discounted_price != 0)){
                    amount_to_pay = this.refcode_discounted_price;
                }else{
                    amount_to_pay = this.selected_plan_product_service_item.product_item_price;
                }
            
                //RAVEPAY-SETUP
                var x = getpaidSetup({
                    // PBFPubKey: "FLWPUBK-2369bd1229e8ed1b28b21370100f73e8-X", //api public key//live //ch@wbn
                    PBFPubKey: "FLWPUBK-8b636e40e721ae65285c678950808ef5-X", //test //devlot
                    customer_email: self.payment_payer_email, // "mail@gmail.com"
                    amount:  (Math.round(amount_to_pay)),//(Math.round(this.total_orders_amount * 100)),
                    customer_phone: self.payment_payer_phone, //"234099940409"
                    currency: "NGN",
                    payment_method: "both",
                    txref: self.payment_ref,//"GWLOG"+(new Date().getTime()),
                    meta: [{
                        metaname: "GalleryWebsiteOrders",
                        metavalue: self.payment_payer_name,
                        metaservice: self.payment_payer_name + " - " + self.payment_payer_phone + " - ORDER - " + self.selected_plan.product_name
                    }],
                    onclose: function() {
                        self.data_boarding_message = "Payment was Stopped.";
                    },
                    callback: function(response) {
                        var txref = response.tx.txRef; // collect flwRef returned and pass to a server page to complete status check.
                        var tx_amount = response.tx.amount;
                        if (
                            response.tx.chargeResponseCode == "00" ||
                            response.tx.chargeResponseCode == "0"
                        ) {
                            self.processing = true;
                            
                            // redirect to a success page
                        // console.log("good to go!"+txref)

                            //server validation
                            // let payload =
                            // {
                            //    "SECKEY": "FLWSECK-a235ea72184ac4d7c07ea2e356682cd7-X", //use API secret key
                            //     "txref": txref
                            // };
                            // service.verifyRavePayment(self, payload).then(response => {
                            //     // console.log(response); // 42
                            //     // console.log(response.body.data.status); // 42
                            //     if ((response.body.data.status === "successful") && (response.body.data.chargecode == "00")) {
                            //         //check if the amount is same as amount you wanted to charge just to be very sure
                            //         self.payment_message = "Payment processed successfully, check your email for your receipts."
                                    
                            //         if (response.body.data.amount === tx_amount) {
                            //             //enter into db
                                        

                                        // let txn_payload={
                                        //     "txn_ref": txref,
                                        //     "pay": self.user.user_id,
                                        //     "txn_amount": self.wallet_transaction.topay_amt,
                                        //     "processing_fee": self.wallet_transaction.processing_fee,
                                        //     "topup_by_admin": 0,
                                        //     "total_amount": tx_amount
                                        // };
                                        
                                        self.updatePayment(txref);
                                //     }
                                // }
                            
                                
                            // }).catch((err) => {
                            //     //console.log(34545)
                            //    // console.log(err)
                            // })
                            //...//....server validation
                    } else {
                        // redirect to a failure page.
                        //console.log("bad to go!"+txref)
                        // self.wallet_payment_message = "Payment unsuccessfull. please try again or contact us"
                    }
    
                    x.close(); // use this to close the modal immediately after payment.
                }
                });
                //RAVEPAY-SETUP
            }

        },

        // update payments
        updatePayment(payment_ref) {
            //notify server of payment
            this.notifyPayments(15,payment_ref,0); //15--Subscription-Paid
            //log transctions
            //.......................................

            // var payload = {
            //     payment_order_ref: payment_ref,
            //     payment_user_id: this.user.user_id
            // }
            //.......................................
            
            //then proceed
            let navi = this.$router;

            
            this.payment_successful = true;
            if(this.selected_plan_product_service_item.product_item_price != 0){ //not free account
                this.payment_successful_message = "Payment Successful...";
            }   
            
            //set up account on gw
            if(this.set_up_with_existing_account){
               this.setUpExistingAccount();
            }
            if(this.set_up_with_new_account){
                this.setUpNewAccount();
            }

            //if upgrade process
            if(this.set_upgrade_plan_process){
                this.upgradePlan();
            }
        },

        //notify payment
        notifyPayments(status,payment_ref,business_ordered){
            var payload = {
                order_status: status,
                order_payment_ref: payment_ref,
                order_business: business_ordered,
            }
            service.updateAppSubscriptionOrder(this, payload).then(response => {
                if(response.body.status == 200) {
                    this.data_boarding_message = "Payment Updated....";
                }
            }).catch((err) => {})

        },

        //flow-01
        //changed because of flow02
        setUpExistingAccountB4Flow01(){
            //register users business to gallery app
            // this.disable_btn = true;
            this.activate_processing();
            var credentials = {
                business_user_name: this.user.user_business,
                business_group: service.market_app_name,
                business_subscription: this.selected_plan_product_service_item.product_item_id
            }
            
            let navi = this.$router; 
            service.addExistingBusiness(this, credentials).then(function(data) {
                if((data.body.status == 201) || (data.body.status == 200)) {
                    //data.body.status == 200...already exists so login and move to sellpoint..//recode later to inform user
                    //.....usually happens during testings
                    //data.body.status == 201 ...successfully registered..proceed
                    // this.user.user_business = data.body.data_business_username; //overide from server
                    this.data_boarding_message = "Sellpoint Setup Successful...";
                     //navi.push('/'+this.user.user_business);
                    //log user in
                    var credentials = {
                        user_email: this.user.user_email,
                        user_password: this.user.user_password
                    }
                    service.loginUser(this, credentials).then(response => {
                        if(response.body.status == 200) {
                            let data = response.body.data;
                            localStorage.setItem("sp_user", data.user_name); 
                            localStorage.setItem("sp_token", data.user_session_key); //store session key here linked to session well @server
                            localStorage.setItem("sp_token_key", data.user_token_key); 
                           
                            //all good
                            //and ask user for business name to create the sp
                           ////DEPRAC $('#purchaseModal').modal('hide');
                            navi.push('/'+this.user.user_business);
                        }
                    }).catch((err) => {
                        if(err.status == 404) {
                            toastr.warning("invalid login credentials", 'Warning!'); 
                            // this.disable_btn = false;
                            this.deactivate_processing();
                        }
                    })
                }
            }).catch((err) => {
                if(err) {
                   // console.log(err)
                    //toastr.warning("Something went wrong", 'Warning!'); 
                    // this.disable_btn = false;
                    this.deactivate_processing();
                }
            })
        },

        //flow-02
        //changes user-reg/validates-account->order-is-made->payment-is-made-and-updated-at-server->business-is-created
        setUpExistingAccount(){
            //register users business to gallery app
            // this.disable_btn = true;
            this.activate_processing();
            var credentials = {
                business_user_name: this.user.user_business,
                business_group: service.market_app_name,
                business_subscription: this.selected_plan_product_service_item.product_item_id
            }
            
            let navi = this.$router; 
            service.addExistingBusiness(this, credentials).then(function(data) {
                if((data.body.status == 201) || (data.body.status == 200)) {
                    //data.body.status == 200...already exists so login and move to sellpoint..//recode later to inform user
                    //.....usually happens during testings
                    //data.body.status == 201 ...successfully registered..proceed
                    // this.user.user_business = data.body.data_business_username; //overide from server
                    this.data_boarding_message = "Sellpoint Setup Successful...";

                    //notify server of Order-Delivered
                    this.notifyPayments(16,this.payment_ref,this.user.user_business); //15--Subscription-Delivered

                    //move to sellpoint
                    navi.push('/'+this.user.user_business);
                }
            }).catch((err) => {
                if(err) {
                   // console.log(err)
                    //toastr.warning("Something went wrong", 'Warning!'); 
                    // this.disable_btn = false;
                    this.deactivate_processing();
                }
            })
        },

        //flow-01
        setUpNewAccountB4Flow02(){
            //create account by registering user
            // this.disable_btn = true;
            this.activate_processing();
            var credentials = {
                user_name: this.payment_payer_name,
                user_phone: this.payment_payer_phone,
                user_email: this.payment_payer_email,
                user_address:  '',
                user_state: '',
                user_city: '',
                user_password: this.user.user_password
            }


            let navi = this.$router;

            //test data
            let data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let email_test = re.test(String(this.payment_payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            let phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
            if((email_test == false) || (this.payment_payer_name == " ") || (phone_test == false)){
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
                this.deactivate_processing();
            }else{
                data_test = true;
                this.data_error_message = "";
            }
            if(data_test){
                if(credentials.user_name != undefined && credentials.user_address != undefined && credentials.user_phone != null &&
                credentials.user_email != null && credentials.user_password != null) {
                    service.regUser(this, credentials).then(function(data) {
                        if(data.body.status == 201) {
                        // toastr.success("Registration Successful", 'Success!');
                        this.data_boarding_message ="Registration Successful...";
                            //log user in
                            var credentials = {
                                user_email: data.body.data.user_email,
                                user_password: this.user.user_password
                            }
                            service.loginUser(this, credentials).then(response => {
                                if(response.body.status == 200) {
                                    let data = response.body.data;
                                    localStorage.setItem("sp_user", data.user_name); 
                                    localStorage.setItem("sp_token", data.user_session_key); //store session key here linked to session well @server
                                    localStorage.setItem("sp_token_key", data.user_token_key); 
                                
                                    //all good
                                    //reauth and preset to get actual user details
                                    this.preset();
                                    //and ask user for business name to create the sp
                                    let self = this;
                                    setTimeout(function(){ 
                                        self.set_up_business = true; 
                                       // $('#purchaseModal').modal('hide');
                                       //DEPRAC $('#newBusinessModal').modal('show');
                                       self.data_boarding_message = " "; //reset
                                       self.setComponent('show-new-business-form','');
                                       self.deactivate_processing();
                                       //srolls to the very top
                                        var top = document.getElementById("banner").offsetTop; //Getting Y of target element //general addPanelView otherwise use specific names
                                        window.scrollTo(0, top); 
                                    }, 3000); //wait for 3sec and c
                                    
                                }
                            }).catch((err) => {
                                if(err.status == 404) {
                                    //toastr.warning("invalid login credentials", 'Warning!'); 
                                    this.data_error_message = "invalid login credentials..";
                                    // this.disable_btn = false;
                                    this.deactivate_processing();
                                }
                            })
                        }else if(data.body.status == 409) {
                            //toastr.warning("This User is already registered", 'Warning!');
                            this.data_error_message = "This User is already registered..";
                            // this.disable_btn = false;
                            this.deactivate_processing();
                        }
                    })
                }else {
                    //toastr.error('Kindly fill all fields', 'Warning!');
                    this.data_error_message = "Kindly fill all fields...";
                    // this.disable_btn = false;
                    this.deactivate_processing();
                }
            }
        },

        //flow-02
        setUpNewAccount(){
            //ask user for business name to create the sp
            let self = this;
            setTimeout(function(){ 
                self.set_up_business = true; 
               // $('#purchaseModal').modal('hide');
               //DEPRAC $('#newBusinessModal').modal('show');
               self.data_boarding_message = " "; //reset
               self.setComponent('show-new-business-form','');
               self.deactivate_processing();
               //srolls to the very top
                var top = document.getElementById("banner").offsetTop; //Getting Y of target element //general addPanelView otherwise use specific names
                window.scrollTo(0, top); 
            }, 3000); //wait for 3sec and c
        },

        validateUserName(){
            service.validateBusinessUserName(this, this.business).then(response => {
                if(response.body.status != 200) {
                    this.validate_user_name_error = true;
                    this.validate_user_name_message = "This username already exist";
                    this.deactivate_processing();
                }
            }).catch((err) => {
                //log it
                this.validate_user_name_error = true;
                this.validate_user_name_message = "This username already exist";
                this.deactivate_processing();
            })
        },
        
        setUpNewAccountBusiness(){
            this.resetMessages();
            // this.disable_btn = true;
            this.activate_processing();
            var credentials = {
                business_name: this.business.business_name,
                business_user_name: this.business.business_user_name,
                business_category: this.business.business_category || 1,
                business_owner: this.user.user_id,
                business_group: service.market_app_name,
                business_layout: 3, //gallery
                business_subscription: this.selected_plan_product_service_item.product_item_id
            }
            let navi = this.$router;
            if(this.validate_user_name_error){
                //toastr.error('This Username already exists', 'Warning!');
                this.data_error_message = "This Username already exists..";
                this.deactivate_processing();
            }else{
                if(credentials.business_name != undefined && credentials.business_category != undefined) {
                    service.addNewBusiness(this, credentials).then(function(data) {
                        if(data.body.status == 201) {
                            // toastr.success("Sellpoint Creation Successfull", 'Success!');
                            this.business.business_user_name = data.body.data_business_username; //overide from server
                            this.data_boarding_message = "Sellpoint Creation Successful.";
                            
                            //notify server of Order-Delivered
                            this.notifyPayments(16,this.payment_ref,this.business.business_user_name); //16--Subscription-Delivered

                                
                            ///DEPRAC//$('#newBusinessModal').modal('hide');
                            navi.push('/'+this.business.business_user_name);
                        }else{
                            this.data_error_message = "This Username already exists";
                            this.deactivate_processing();
                        }
                    }).catch((err) => {
                        if(err) {
                            // toastr.warning("Something went wrong", 'Warning!'); 
                            this.data_error_message = "Something went wrong";
                            // this.disable_btn = false;
                            this.deactivate_processing();
                        }
                    })
                }else {
                    // toastr.error('Kindly fill all fields', 'Warning!');
                    this.data_error_message = "Kindly fill all fields";
                    // this.disable_btn = false;
                    this.deactivate_processing();
                }
            }
        },
        
        upgradePlan(){
            this.activate_processing();
            var credentials = {
                business_user_name: this.upgrade_business,
                business_group: service.market_app_name,
                business_subscription: this.selected_plan_product_service_item.product_item_id,
                business_subscription_amount_paid: this.selected_plan_product_service_item.product_item_price,
            }
            
            let navi = this.$router; 
            service.upgradeBusinessMarketSubscription(this, credentials).then(function(data) {
                if(data.body.status ==  200) {
                    //move to the business
                    navi.push('/'+this.upgrade_business);
                }
            }).catch((err) => {
                if(err) {
                    this.data_error_message = "Something went wrong";
                    this.deactivate_processing();
                }
             });
        },

        getBusinessCategories() {
            service.getCategories(this).then(function(data) {
                this.categories = data.body.data;
                //seperate products and services categories
                this.categories.forEach(function(element) {
                    if(element.category_type == 1){
                        this.business_product_categories.push(element);
                    }
                    if(element.category_type == 2){
                        this.business_service_categories.push(element);
                    }
                }, this);
            })
        },
        
    },
    mounted(){
        //always jump to top of page hack
        var top = document.getElementById("topwrap").offsetTop;
        window.scrollTo(0, top); 
        //continue
    },
    created: function(){
        //check for referral
        if(this.$route.params.refcode){
            localStorage.removeItem("gwrfc"); //remove former code
            localStorage.setItem("gwrfc", this.$route.params.refcode);
            this.refcode = this.$route.params.refcode;
            this.getReferralOptions();
        }else if((localStorage.getItem("gwrfc")) && (localStorage.getItem("gwrfc") != '')){
            this.refcode = localStorage.getItem("gwrfc");
            this.getReferralOptions();
        }
        if(this.$route.query.upgrade){
            this.set_upgrade_plans = true; //mus not show purchase section
        }
        this.preset();
        this.getSellpointMarket();
        this.getBusinessCategories();
    }
}


// WEBPACK FOOTER //
// ./src/pages/Purchase/script.js